module.exports = __webpack_public_path__ + "static/img/关于博信城.97c63263.png";